module.exports = __webpack_public_path__ + "img/noCompany.00e57fb7.png";